<template>
  <v-dialog
    persistent
    :max-width="644"
    :value="value"
    @click:outside="$emit('close')"
  >
    <v-card
      :min-height="555"
      class="authorize-container"
    >
      <template v-if="authorized">
        <div style="display: flex; flex-direction: column; justify-content: flex-start">
          <img
            src="@/assets/Woman_Yoga_Outline.svg"
            height="139"
            width="189"
            style="margin: 0 auto 52px"
          >
          <h4 style="text-align: center; margin-bottom: 46px">
            Your request has been sent to {{ integration.name }}.
            Sit back and relax. We’ll contact you once your request is approved.
          </h4>
          <v-btn
            color="primary"
            style="width: 293px"
            class="mx-auto"
            @click="$emit('close')"
          >
            OK
          </v-btn>
        </div>
      </template>
      <template v-else>
        <h4 style="text-align:center">
          {{ integrationName }} wants to access your NoiseAware Organization
        </h4>
        <div class="authorize-logos">
          <img src="../../assets/NoiseAware_Logo_Bug_Green.svg">
          <template v-if="!isAutoResolve">
            <v-icon
              size="54"
              color="#CECECE"
              class="mx-7"
            >
              $faArrowsHLight
            </v-icon>
            <img
              :src="integration.logo"
              class="partner-logo"
            >
          </template>
        </div>
        <div>
          <h3>
            {{ integrationName }} will be able to:
          </h3>
          <div class="authorize-details">
            <div class="authorize-detail-item">
              <v-icon
                size="18"
                color="success"
                class="mr-6 mt-1"
              >
                $faCheckCircleRegular
              </v-icon>
              <div>Access all data on your NoiseAware account including properties, users, sensors, and noise data</div>
            </div>
            <hr>
            <div class="authorize-detail-item">
              <v-icon
                size="18"
                color="success"
                class="mr-6 mt-1"
              >
                $faCheckCircleRegular
              </v-icon>
              <div>Have full admin rights to edit data on your NoiseAware account</div>
            </div>
          </div>
        </div>
        <div class="btn-container">
          <v-btn
            color="primary"
            @click="$emit('authorize', integration.id)"
          >
            Authorize
          </v-btn>
          <v-btn
            class="mt-4"
            @click="$emit('cancel')"
          >
            Cancel
          </v-btn>
        </div>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
  import { AUTO_RESOLVE } from '@/helpers/integration-constants.js'
  export default {
    name: 'AuthorizeIntegrationModal',
    props: {
      integration: Object,
      logo: String,
      value: Boolean,
      authorized: Boolean,
    },
    computed: {
      isAutoResolve () {
        return this.integration.name === AUTO_RESOLVE
      },
      integrationName () {
        return this.isAutoResolve ? 'AutoResolve' : this.integration.name
      },
    },
  }
</script>

<style lang="scss" scoped>
.authorize-container {
  padding: 83px 134px 73px;
  background-color: $na-off-white;
}
.authorize-details {
  margin-top: 18px;
  & hr {
    background-color:#CECECE;
    height: 1px;
    border:none;
    margin: 18px 0 13px;
  }

}
.authorize-detail-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.authorize-logos {
  margin: 27px 0 45px;
  display: flex;
  flex-direction: row;
  align-items: middle;
  justify-content: center;
}
.partner-logo {
  max-height: 60px;
  max-width: 60px;
}
.btn-container {
  display: flex;
  flex-direction: column;
  margin-top: 59px;
  & button {
    flex: 1 1 auto;
    width: 293px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
